(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/coupon.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/coupon.js'); 
'use strict';

svs.maltipset.models.Coupon = Backbone.Model.extend({
  preserve: true,
  preserveBindings: true,
  initialize: function() {
    this.set(
      'system',
      svs.maltipset.models.storageCoupon.get('system') ||
          svs.maltipset.constants.SYSTEM.NO_SYSTEM,
      { silent: true }
    );

    if (
      svs.maltipset.models.storageCoupon.get('drawNumber') ===
        this.get('draw').get('drawNumber')
    ) {
      this.set(
        'board',
        new svs.maltipset.collections.Board(undefined, {
          selectedMatchIndexes: svs.maltipset.models.storageCoupon.getSelectedMatchIndexes(),
          coupon: this,
          system:
              svs.maltipset.models.storageCoupon.get('system') ||
              svs.maltipset.constants.SYSTEM.NO_SYSTEM,
          xpertBaseRowMode:
              svs.maltipset.models.storageCoupon.get('xpertBaseRowMode') ||
              false,
          reset: false
        }),
        { silent: true }
      );
      this.set(
        'hasMarkedMatches',
        _.filter(
          svs.maltipset.models.storageCoupon.get('selectedMatches'),
          function(arr) {
            return arr.length;
          }
        ).length > 0,
        { silent: true }
      );
      this.updateSportkryss(
        svs.maltipset.models.storageCoupon.get('sportkryssBet')
      );
      this.updateNumWeeks(svs.maltipset.models.storageCoupon.get('numWeeks'));
      this.set(
        {
          xpertBaseRowMode:
              svs.maltipset.models.storageCoupon.get('xpertBaseRowMode') ||
              false,
          baseRow: svs.maltipset.models.storageCoupon.get('baseRow'),
          actionBar: svs.maltipset.models.storageCoupon.get('actionBar'),
          xpertSize: svs.maltipset.models.storageCoupon.get('xpertSize'),
          xpertSystem: svs.maltipset.models.storageCoupon.get('xpertSystem'),
          isProlonging: svs.maltipset.models.storageCoupon.get('isProlonging')
        },
        { silent: true }
      );
    } else {
      this.set(
        'board',
        new svs.maltipset.collections.Board(undefined, {
          coupon: this,
          system: svs.maltipset.constants.SYSTEM.NO_SYSTEM
        }),
        { silent: true }
      );
    }
    this.setInitialData(true);
    this.getAccountBalance();
    this.listenTo(this, 'change:system', this.resetCoupon, this);
    this.listenTo(
      this,
      'change:numWeeks change:sportkryssBet',
      this.costChanged,
      this
    );
    this.listenTo(
      this,
      'change:totalSelectedMatches',
      this.onTotalSelectedMatchesChange,
      this
    );
    this.listenTo(
      this.get('draw').get('matchList'),
      'currentMatchSet',
      this.setSelectedMatch
    );
  },

  isBoardValid: function() {
    if (
      svs.utils.ns.isNamespace(
        'svs.core.config.data.svsconfig.isSelfService'
      ) &&
        svs.core.config.data.svsconfig.isSelfService === true
    ) {
      return this.get('board').getTotalCompleteRows() > 3;
    }
    return this.get('board').getTotalCompleteRows() > 0;
  },

  setInitialData: function(silent) {
    var totalCompleteRows = this.get('board').getTotalCompleteRows(),
      coupon = {
        currentRow: this.get('board').first(),
        totalSelectedMatches: this.get('board').getTotalSelectedMatches(),
        totalCompleteRows: totalCompleteRows,
        isValid: this.isBoardValid(),
        totalCost: this.getTotalCost(totalCompleteRows),
        numberOfSelectedMatches: this.get('board')
          .first()
          .get('numberOfSelectedMatches'),
        matchesLeftToSelect: this.get('board')
          .first()
          .getMatchesLeftToSelect(),
        matchesLeftToMaxSelect: this.get('board')
          .first()
          .getMatchesMaxLeftToSelect(),
        activeRowNum: 0
      };

    this.set(coupon, { silent: silent || false });
    this.listenTo(
      this.get('currentRow'),
      'change:numberOfSelectedMatches',
      this.numberOfSelectedMatchesChanged,
      this
    );
  },
  getTotalCost: function(totalCompleteRows) {
    var sportkryssCost = this.get('hasSportkryssBet')
        ? this.get('sportkryssBet').rowPriceMulti * 10
        : 0;
    var totalCost =
        (totalCompleteRows * svs.maltipset.constants.ONE_ROW_COST +
          sportkryssCost) *
        this.get('numWeeks');

    if (totalCost === 0) {
      return svs.maltipset.constants.ONE_ROW_COST;
    }
    return totalCost;
  },
  getAccountBalance: function() {
    var self = this;
    if (self.isEnabled()) {
      svs.components.account_balance.get(function(balance) {
        self.set(
          'accountBalance',
            balance != null ? svs.utils.format.Currency(balance) : null
        );
        self.set(
          'userAccountBalace',
            balance != null ? svs.utils.format.Currency(balance) : null
        );
      });

      svs.components.account_balance.on(
        'change',
        function(balance) {
          self.set(
            'accountBalance',
              balance != null ? svs.utils.format.Currency(balance) : null
          );
          self.set(
            'userAccountBalace',
              balance != null ? svs.utils.format.Currency(balance) : null
          );
        },
        this
      );
    }
  },
  getBoardData: function(getIncompleteRows) {
    return this.get('board').getBoardData(getIncompleteRows);
  },
  resetCoupon: function() {
    this.stopListening(
      this.get('currentRow'),
      'change:numberOfSelectedMatches'
    );
    svs.maltipset.models.storageCoupon.storeSelectedMatches(
      this.get('draw').get('drawNumber'),
      this.get('system'),
      this.getBoardData(true)
    );
    this.setInitialData(false);
    this.get('draw')
      .get('matchList')
      .updateMarkedMatchesCount(this.get('board'));
  },
  stopBaseRowEdit: function() {
    this.get('board').resetAndInitializeRows({ system: this.get('system') });
    this.removeActionbar();
    var xpertObject = {
      baseRow: undefined,
      xpertBaseRowMode: false,
      xpertSize: 0
    };
    svs.maltipset.models.storageCoupon.set(xpertObject);
    this.set(xpertObject);

    this.resetCoupon();
    this.trigger('stopBaseRowEdit');
  },
  createBaseRow: function() {
    this.get('board').setBoardToBaseRow();
    this.resetCoupon();
    var baseRowObject = {
      xpertBaseRowMode: true,
      actionBar: svs.maltipset.constants.ACTIONBARS.BASEROW
    };

    this.set(baseRowObject);
    svs.maltipset.models.storageCoupon.set(baseRowObject);

    this.trigger('createBaseRow');
  },
  newXpert: function(useBaseRow) {
    this.trigger('xpert:startLoad');
    var xpert,
      self = this;

    if (useBaseRow) {
      xpert = new svs.maltipset.models.Xpert({
        baseRow: this.get('baseRow') || this.get('board').getBoardData(true),
        xpertSize: this.get('xpertSize'),
        system: this.get('system'),
        drawNumber: this.get('draw').get('drawNumber')
      });
    } else {
      var xpertOptions = {
        xpertSize: this.get('xpertSize'),
        system: this.get('system'),
        drawNumber: this.get('draw').get('drawNumber')
      };

      xpert = new svs.maltipset.models.Xpert(xpertOptions);
    }
    this.listenToOnce(xpert, 'error', function(model, resp) {
      self.trigger('xpert:doneLoad xpert:error', resp);
    });
    this.listenToOnce(xpert, 'sync', function(model) {
      self.get('board').setBoardFromXpert(model);
      var xpertObject = {
        xpertSize: model.get('xpertSize'),
        xpertBaseRowMode: false,
        actionBar: svs.maltipset.constants.ACTIONBARS.XPERT,
        xpertSystem: svs.maltipset.constants.XPERT_PROPERTIES.WEIGHTEDQP,
        isValid: true
      };

      if (useBaseRow) {
        xpertObject.baseRow = model.get('baseRow');
        xpertObject.xpertSystem =
            svs.maltipset.constants.XPERT_PROPERTIES.PARTIALQP;
      } else {
        xpertObject.baseRow = undefined;
      }

      self.set(xpertObject, { silent: true });
      svs.maltipset.models.storageCoupon.set(xpertObject);
      self.resetCoupon();

      self.trigger('change:isValid change:actionBar xpert:doneLoad');

      self.trigger('stopBaseRowEdit');

      self.stopListening(xpert, 'error');
    });

    xpert.fetch();
  },
  removeXpert: function() {
    if (this.get('xpertSystem') !== 'NOEXPERT') {
      this.removeActionbar();
    }
    var xpertObject = {
      baseRow: undefined,
      xpertSize: 0,
      xpertSystem: svs.maltipset.constants.XPERT_PROPERTIES.NOXPERT
    };

    this.set(xpertObject, { silent: true });
    svs.maltipset.models.storageCoupon.set(xpertObject);
    this.trigger('xpertRemoved');
  },
  changeSystem: function(toSystem) {
    if (this.get('xpertBaseRowMode')) {
      this.stopBaseRowEdit();
    }

    if (this.get('xpertSize')) {
      this.removeXpert();
    }

    this.get('board').convertSystem(this.get('system'), toSystem);

    var bar =
        toSystem !== svs.maltipset.constants.SYSTEM.NO_SYSTEM
          ? svs.maltipset.constants.ACTIONBARS.SYSTEM
          : svs.maltipset.constants.ACTIONBARS.NO_BAR;

    svs.maltipset.models.storageCoupon.set('actionBar', bar);

    this.set(
      {
        system: toSystem,
        actionBar: bar
      },
      { silent: true }
    );

    this.trigger('change:system', toSystem);
    _.defer(function() {
      svs.components.loader.hide();
    });
  },
  removeActionbar: function() {
    this.set('actionBar', svs.maltipset.constants.ACTIONBARS.NO_BAR);
    svs.maltipset.models.storageCoupon.set(
      'actionBar',
      svs.maltipset.constants.ACTIONBARS.NO_BAR
    );
  },
  canConvertToSystem: function(toSystem) {
    return this.get('board').canConvertSystem(this.get('system'), toSystem);
  },
  numberOfSelectedMatchesChanged: function(row) {
    var totalCompleteRows = this.get('board').getTotalCompleteRows();

    if (row.get('lastMatchChanged')) {
      this.get('draw')
        .get('matchList')
        .at(row.get('lastMatchChanged').index)
        .markChanged(row.get('lastMatchChanged').mark);
    }

    var storeObject = {
      totalSelectedMatches: this.get('board').getTotalSelectedMatches(),
      numberOfSelectedMatches: row.get('numberOfSelectedMatches'),
      totalCompleteRows: totalCompleteRows,
      isValid: this.isBoardValid(),
      totalCost: this.getTotalCost(totalCompleteRows),
      matchesLeftToSelect: row.getMatchesLeftToSelect(),
      matchesLeftToMaxSelect: row.getMatchesMaxLeftToSelect(),
      xpertSystem:
          this.get('xpertSize') > 0
            ? svs.maltipset.constants.XPERT_PROPERTIES.MODIFIEDQP
            : svs.maltipset.constants.XPERT_PROPERTIES.NOXPERT,
      baseRow: undefined,
      isProlonging: false
    };
    this.set(storeObject);
    svs.maltipset.models.storageCoupon.set(storeObject);

    if (this.get('actionBar') === svs.maltipset.constants.ACTIONBARS.XPERT) {
      this.removeActionbar();
    }

    svs.maltipset.models.storageCoupon.storeSelectedMatches(
      this.get('draw').get('drawNumber'),
      this.get('system'),
      this.getBoardData(true)
    );
  },
  setSelectedRow: function(index) {
    this.stopListening(
      this.get('currentRow'),
      'change:numberOfSelectedMatches'
    );
    var currentRow = this.get('board').at(index);

    this.get('board').models.forEach(function(row) {
      row.set('active', false);
    });

    currentRow.set('active', true);

    this.get('board').currentRowIndex = index;
    this.set({
      currentRow: currentRow,
      numberOfSelectedMatches: currentRow.get('numberOfSelectedMatches'),
      matchesLeftToSelect: currentRow.getMatchesLeftToSelect(),
      activeRowNum: index
    });
    this.listenTo(
      this.get('currentRow'),
      'change:numberOfSelectedMatches',
      this.numberOfSelectedMatchesChanged,
      this
    );
  },
  pay: function() {
    var self = this,
      bets = this.get('prolongWager')
          ? { bets: this.get('prolongWager').get('bets') }
          : {};

    var wager = new svs.maltipset.models.Wager(bets, {
      coupon: this,
      numWeeks: this.get('numWeeks')
    });

    if (
      this.get('hasSportkryssBet') &&
        !_.where(wager.get('bets'), { productId: 'SPORTJOKER' }).length
    ) {
      var sportkryssBet = _.clone(this.get('sportkryssBet'));
      sportkryssBet.betAmountSalesGroup1 = svs.utils.format.CurrencyAsJupiterString(
        sportkryssBet.rowPriceMulti * 10 * sportkryssBet.numDraws
      );
      sportkryssBet.drawNum = 0;
      wager.get('bets').push(sportkryssBet);
    }

    var isSelfService = svs.utils.ns.isNamespace(
      'svs.core.config.data.svsconfig.isSelfService'
    )
        ? svs.core.config.data.svsconfig.isSelfService
        : false;

    if (isSelfService) {
      svs.components.selfservice.container.open(
        [wager.toJSON()],
        false,
        function() {
          self.set({
            numWeeks: 1,
            sportkryssBet: null,
            hasSportkryssBet: false,
            hasMarkedMatches: false
          });
          self.removeXpert();
          self.get('board').currentRowIndex = 0;
          self.empty();
          self.trigger('destroyBetslipAfterPayment', true);
        },
        function() {}
      );
    } else {
      wager.pay(
        function(data) {
          var roomKeys,
            draw = self.get('draw'),
            productId = draw.get('productId'),
            wagerSerial = data.wagerClientSerial,
            numWeeks = self.get('numWeeks');
          if (numWeeks === 1) {
            if (draw) {
              roomKeys = draw.get('roomKeys');
            }
            if (roomKeys) {
              svs.components.app_notifications.setUpAppNotifications({
                roomKeys: roomKeys,
                productId: productId,
                wagerSerial: wagerSerial
              });
            }
          }
          self.set({
            numWeeks: 1,
            sportkryssBet: null,
            hasSportkryssBet: false,
            hasMarkedMatches: false
          });

          self.removeXpert();
          self.get('board').currentRowIndex = 0;
          if (svs.core.detect.feature('ft-maltipset-direct-play')) {
            self.trigger('destroyBetslipAfterPayment', true);
            self.empty();
            self.trigger('wager:paySuccess', wager);
          } else {
            self.trigger('wager:paySuccess', wager);
            self.empty();
            self.trigger('destroyBetslipAfterPayment', true);
          }
        },
        function(response) {
          self.trigger('wager:payError', response);
        }
      );
    }
  },
  empty: function(clearSystem) {
    if (clearSystem) {
      this.set('system', svs.maltipset.constants.SYSTEM.NO_SYSTEM, {
        silent: true
      });
    }
    this.removeXpert();
    this.get('board').currentRowIndex = 0;
    this.trigger('coupon:empty');
    this.get('draw')
      .get('matchList')
      .updateMarkedMatchesCount(this.get('board'));
    this.get('draw')
      .get('matchList')
      .trigger('reset');
    this.set('isValid', false);
    svs.maltipset.models.storageCoupon.empty();
    this.resetCoupon();
  },
  updateNumWeeks: function(numWeeks) {
    this.set('numWeeks', numWeeks);
    if (this.get('hasSportkryssBet')) {
      this.get('sportkryssBet').numDraws = numWeeks;
      svs.maltipset.models.storageCoupon.set(
        'sportkryssBet',
        this.get('sportkryssBet')
      );
    }
    svs.maltipset.models.storageCoupon.set('numWeeks', numWeeks);
  },
  updateSportkryss: function(sportkryssBet, forceValid) {
    var valid = this.isBoardValid();

    if (sportkryssBet) {
      sportkryssBet.numDraws = this.get('numWeeks');
    }

    if (
      sportkryssBet &&
        sportkryssBet.jokerBoards &&
        sportkryssBet.jokerBoards[0] &&
        sportkryssBet.jokerBoards[0].boardData
    ) {
      valid =
          valid &&
          sportkryssBet.jokerBoards[0].boardData.length ==
            svs.maltipset.constants.VALID_SPORTKRYSS_LENGTH;
    } else {
      valid = valid && true;
    }

    if (forceValid) {
      valid = true;
    }

    this.set({
      sportkryssBet: sportkryssBet,
      hasSportkryssBet:
          sportkryssBet && sportkryssBet.betAmountSalesGroup1 ? true : false,
      isValid: valid
    });
    svs.maltipset.models.storageCoupon.set('sportkryssBet', sportkryssBet, {
      silent: true
    });
    svs.maltipset.models.storageCoupon.trigger(
      'change',
      svs.maltipset.models.storageCoupon
    );
  },
  costChanged: function() {
    this.set('totalCost', this.getTotalCost(this.get('totalCompleteRows')));
  },
  isEnabled: function() {
    return this.get('draw').isOpen();
  },
  isMOrRSystem: function() {
    return this.get('system') !== svs.maltipset.constants.SYSTEM.NO_SYSTEM;
  },
  onTotalSelectedMatchesChange: function() {
    this.set('hasMarkedMatches', this.get('totalSelectedMatches') > 0);
  },
  prolong: function(enable) {
    this.set('isProlonging', enable);
    svs.maltipset.models.storageCoupon.set('isProlonging', enable);
  },
  setSelectedMatch: function() {
    this.set(
      'selectedMatch',
      this.get('draw')
        .get('matchList')
        .getCurrentMatch()
    );
  },
  setAccountBalance: function(balance) {
    this.set(
      'accountBalance',
        balance != null ? svs.utils.format.Currency(balance) : null
    );
  },
  defaults: function() {
    return {
      numberOfSelectedMatches: 0,
      numWeeks: 1,
      system: svs.maltipset.constants.SYSTEM.NO_SYSTEM,
      hasMarkedMatches: false,
      xpertBaseRowMode: false,
      xpertSystem: svs.maltipset.constants.XPERT_PROPERTIES.NOXPERT,
      actionBar: svs.maltipset.constants.ACTIONBARS.NO_BAR,
      isProlonging: false
    };
  }
});

 })(window);